import { createSelector } from 'reselect';

import mapValues from 'lodash/mapValues';
import pickBy from 'lodash/pickBy';
import getISODay from 'date-fns/get_iso_day';
import isBefore from 'date-fns/is_before';
import itemsWithOverwrittenPriceSelector from 'selectors/itemsWithOverwrittenPriceSelector';
import { scheduleTimeSelector } from 'selectors/scheduleTimeSelector';
import scheduleFilteredMenuSelector from 'selectors/scheduleFilteredMenuSelector';

const availableAtDateItemsSelector = createSelector(
  [
    itemsWithOverwrittenPriceSelector,
    scheduleTimeSelector,
    scheduleFilteredMenuSelector,
  ],
  (items, date, availableMenu) =>
    mapValues(
      pickBy(
        items,
        ({ availableOn, menus }) =>
          availableOn
            .split(',')
            .map(v => +v)
            .includes(getISODay(date)) && menus.includes(availableMenu.id),
      ),
      item => ({
        ...item,
        soldOut: isBefore(date, item.temporarySoldout),
      }),
    ),
);

export default availableAtDateItemsSelector;
